import { useSelector } from 'react-redux'

import { isUserStudentSelector } from '@/selectors'
import settings from "@/utils/settings"
import { translate } from '@/utils/translations'

const DigitalPurchaseMessage = () => {
  const isUserStudent = useSelector(isUserStudentSelector)

  return (
    <If condition={isUserStudent}>
      <div>
        {translate('assets.show.digital_purchase_message')}
        {' '}
        <a
          className='underline vst-btn--transparent styled-as-link
            u-weight--normal custom-style'
          href={settings.vst_support_california_disclosure_url}
          rel="noopener noreferrer"
          target="_blank"
        >
          {translate('common.details')}
        </a>
      </div>
    </If>
  )
}

export default DigitalPurchaseMessage
